export const Uncategorized = 'Без категории';
